import React, { useState, useEffect } from "react";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import InnerBanner from "../../Layouts/InnerBanner";
import Topbar from "../../Layouts/Topbar";
import Header from "../../Layouts/Header";
import Footer from "../../Layouts/Footer";
import { API } from "../../constants";
import useCompanyStore from "../../hooks/useCompanyStore";

const About = () => {
    const { companyId } = useCompanyStore();
  const [faqs, setFaqs] = useState([]);
  const [policy, setPolicy] = useState(null);
  const fetchFaq = async () => {
    try {
      const response = await fetch(API.LIST_FAQ + "/" + companyId, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      });

      const result = await response.json();

      if (!response.ok || result.status === false) {
        setFaqs([]);
        return;
      }

      setFaqs(result?.data || []);
    } catch (error) {
      console.error("Fetch FAQ Error:", error);
      setFaqs([]);
    }
  };
  const fetchAboutUs = async () => {
    try {
     

      const response = await fetch(API.LIST_POLICIES + "/aboutUs" + "/" + companyId , {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result?.message || "Something went wrong");
      }
      setPolicy(result.data);
    } catch (error) {
      console.error("Fetch Policies Error:", error);
    }
  };

  useEffect(() => {
    fetchFaq();
    fetchAboutUs();
  }, []);

  return (
    <div>
      <Topbar />
      <Header />
      <InnerBanner />

      <section className="block less-spacing gray-bg cmn-gap">
        <Container>
          <Row>
            <Col md={12}>
              <div className="sec-box">
                <div className="about-feat">
                  <Row className="align-items-center gy-4 gx-5">
                    <Col md={6}>
                      <img
                        src="assets/images/topbg.jpg"
                        alt="about-img"
                        className="img-fluid"
                      />
                    </Col>

                    <Col md={6}>
                      <div className="about-text">
                        <h2 className="title3">{policy?.title}</h2>
                        <div className="bg-white shadow rounded p-4">
                          <div
                            className="policy-content"
                            dangerouslySetInnerHTML={{
                              __html: policy?.content || "",
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>

                <div className="toggle-wrapper cmn-gap pb-0">
                  <div className="title1-wrapper text-center">
                    <div className="title-inner">
                      <div className="subheading">FAQs</div>
                      <h2>Common FAQs</h2>
                    </div>
                  </div>

                  <Row className="justify-content-center">
                    <Col lg={10}>
                      {faqs.length > 0 ? (
                        <Accordion className="epos-faq" defaultActiveKey="0">
                          {faqs.map((faq, index) => (
                            <Accordion.Item
                              eventKey={String(index)}
                              key={faq._id || faq.id || index}
                            >
                              <Accordion.Header>
                                {faq.question}
                              </Accordion.Header>

                              <Accordion.Body>
                                <p>{faq.answer}</p>
                              </Accordion.Body>
                            </Accordion.Item>
                          ))}
                        </Accordion>
                      ) : (
                        <p className="text-center">No FAQs found.</p>
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </div>
  );
};

export default About;
